import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ZenplansTestDataProviderService } from './../../services/zenplans-test-data-provider.service';
import { UserInfoService } from './../../services/user-info.service';
import { IUser } from './../../models/user.model';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-my-account-tab1',
  templateUrl: './my-account-tab1.component.html',
  styleUrls: ['./my-account-tab1.component.scss']
})
export class MyAccountTab1Component implements OnInit {
  MATitle = 'About Me'

  // MAAboutMeForm = [
  //   {
  //     for: 'firstName',
  //     text: 'First Name',
  //     type: 'text',
  //     className: 'form-control',
  //     id: 'firstName',
  //     placeHolder: 'First Name'
  //   },
  //   {
  //     for: 'lastName',
  //     text: 'Last Name',
  //     type: 'text',
  //     className: 'form-control',
  //     id: 'lastName',
  //     placeHolder: 'Last Name'
  //   },
  //   {
  //     for: 'dateOfBirth',
  //     text: 'Date of Birth',
  //     type: 'date',
  //     className: 'form-control',
  //     id: 'dateOfBirth',
  //     placeHolder: '01/01/60'
  //   },
  //   {
  //     for: 'postCode',
  //     text: 'Post Code',
  //     type: 'text',
  //     className: 'form-control',
  //     id: 'postCode',
  //     placeHolder: 'AB1 2CD'
  //   },
  //   {
  //     for: 'defaultCurrency',
  //     text: 'Default Currency',
  //     type: 'text',
  //     className: 'form-control',
  //     id: 'defaultCurrency'
  //   }
    // {
    //   for: 'MAUpdate',
    //   text: 'Update',
    //   type: 'submit',
    //   className: 'btn next-btn form-control',
    //   id: 'MAUpdate',
    //   value: 'Update'
    // }
  //]
  userForm: FormGroup = new FormGroup({});
  submitted;
  myUser: IUser;
  constructor(private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private zenplansTestDataProviderService: ZenplansTestDataProviderService,
    private userInfo: UserInfoService,
    private calendar: NgbCalendar) { 
      this.userInfo.getMessage().subscribe(user=>{
        this.myUser = JSON.parse(user);
      });
      var kk = this.myUser.dateOfBirth["year"]+"-"+this.myUser.dateOfBirth["month"]+"-"+this.myUser.dateOfBirth["day"];
      this.userForm = this.formBuilder.group({
        firstName: [this.myUser.firstName, Validators.required],
        lastName: [this.myUser.lastName, Validators.required],
        //dateOfBirth: [this.myUser.dateOfBirth["year"]+"-"+this.myUser.dateOfBirth["month"]+"-"+this.myUser.dateOfBirth["day"], Validators.required],
        dateOfBirth: [this.myUser.dateOfBirth, Validators.required],
        postCode: [this.myUser.postCode, Validators.required],
        defaultCurrency: [this.myUser.defaultCurrency, Validators.required],
        //non-visual fields
        email: [this.myUser.email],
        password: [this.myUser.password],
        Id:[this.myUser.Id],
        hearAboutUs:[this.myUser.hearAboutUs],
        offersAuthorization: [this.myUser.offersAuthorization],
        itemName:[this.myUser.itemName]
      });
    }

  async ngOnInit() {
    
    
    var kk = 1;
  }

  async onSubmit() {
    this.submitted = true;
    // stop here if form is invalid
    if (this.userForm.invalid) {
      //return;
    }
    this.userForm.value["lastUpdate"] = new Date();
    this.userForm.value["lastUpdateBy"] = this.myUser.Id;
    //this.userForm.value["dateOfBirth"] = new Date(this.userForm.value["dateOfBirth"]);
    await this.zenplansTestDataProviderService.updateItem(JSON.stringify(this.userForm.value), "users");
    this.userInfo.changeMessage(JSON.stringify(this.userForm.value));
    alert("Success");
    this.router.navigate(['/my-account']);
  }
}
